import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const setViewTypeReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<'grid' | 'list'>) => {
    state.viewType = action.payload;
  });
};

export default setViewTypeReducer;
